import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { Button } from '../components/Button'
import { HeaderLogo } from '../components/HeaderLogo'
import { Input } from '../components/Input'
import { updatePassword } from '../helpers/validationSchema'
import { resetPassword } from '../services/auth'

interface FormValues {
  password: string
  passwordConfirmation: string
}

export const UpdatePassword = () => {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    resolver: yupResolver(updatePassword),
  })
  const { t } = useTranslation()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const token = searchParams.get('token')

  const onSubmit = (data: FormValues) => {
    resetPassword({
      password: data.password,
      passwordConfirmation: data.passwordConfirmation,
      token: token || '',
    })
    console.log(data)
    reset()
  }

  return (
    <div className="flex font-sans">
      <div className="flex h-screen w-full flex-col sm:w-[50%] p-4">
        <HeaderLogo />
        <div className="flex h-screen flex-col items-center justify-center">
          <h2 className="mb-5 font-[500] text-primary sm:text-lg">
            {t('updatepassword')}
          </h2>
          <form
            className="flex max-w-[250px] flex-col items-stretch sm:min-w-[350px]"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Input
              variant={errors.password ? 'danger' : 'primary'}
              placeholder={t('passwordPlaceholder')}
              type="password"
              helperText={errors.password?.message}
              {...register('password')}
            />
            <Input
              variant={errors.passwordConfirmation ? 'danger' : 'primary'}
              placeholder={t('Confirm Password')}
              type="password"
              helperText={errors.passwordConfirmation?.message}
              {...register('passwordConfirmation')}
            />
            <Button
              text={t('btnUpdate')}
              type="submit"
              className="text-white"
            />
          </form>
        </div>
      </div>
      <div className="bg-[#407BFF] sm:h-screen sm:w-[50%]"></div>
    </div>
  )
}
